/**
 * Shared language options for SelectLanguages*Form and CampaignLogs.
 * Re-exports platform options and provides getLanguageLabel for log display.
 */
import {
  SPANISH,
  ENGLISH,
  PORTUGUESE,
  FRENCH,
  RUSSIAN,
  JAPANESE,
  HINDI,
  ARABIC,
  BENGALI,
  PUNJABI,
  GERMAN,
  JAVANESE,
  KOREAN,
  INDONESIAN,
  TURKISH,
  BULGARIAN,
  SLOVAK,
  CROATIAN,
  DANISH,
  UKRAINIAN,
  ENGLISH_US,
  ENGLISH_UK,
  SPANISH_SPAIN,
  PORTUGUESE_BRAZIL,
  PORTUGUESE_PORTUGAL,
  FRENCH_FRANCE,
  FRENCH_CANADA,
  MANDARIN,
  TRADITIONAL_CHINESE_HONG_KONG,
  TRADITIONAL_CHINESE_TAIWAN,
  JAPANESE_KANSAI,
  NORWEGIAN_BOKMAL,
  NORWEGIAN_NYNORSK,
  CATALAN,
  CZECH,
  WELSH,
  BASQUE,
  FINNISH,
  GALICIAN,
  HUNGARIAN,
  ITALIAN,
  DUTCH,
  FRISIAN,
  POLISH,
  ROMANIAN,
  SLOVENIAN,
  SWEDISH,
  FLEMISH,
  ESPERANTO,
  ESTONIAN,
  FAROESE,
  GREEK,
  ICELANDIC,
  IRISH,
  LATVIAN,
  LITHUANIAN,
  MACEDONIAN,
  THAI,
  VIETNAMESE,
  KHMER,
  FILIPINO,
  MALAY,
  GUJARATI,
  KANNADA,
  TAMIL,
  TELUGU,
  MALAYALAM,
  URDU,
  HEBREW,
  PERSIAN,
  NORTHERN_KURDISH_KURMANJI,
  ARMENIAN,
  AZERBAIJANI,
  BELARUSIAN,
  BOSNIAN,
  GEORGIAN,
  KAZAKH,
  MONGOLIAN,
  SERBIAN,
  TAJIK,
  UZBEK,
  AFRIKAANS,
  SWAHILI,
  ALBANIAN,
  CEBUANO,
  GUARANI,
  MARATHI,
  NEPALI,
  PASHTO,
  SINHALA,
  CHINESE,
  ASSAMESE,
  HARYANAVI,
  BIHARI,
  ORIYA,
  RAJASTHANI,
  NORWEGIAN,
} from "../../i18n/keysTranslations";

export const LANGUAGE_OPTIONS_META = [
  {
    label: ENGLISH_US,
    value: 6,
  },
  {
    label: CATALAN,
    value: 1,
  },
  {
    label: CZECH,
    value: 2,
  },
  {
    label: CEBUANO,
    value: 56,
  },
  {
    label: WELSH,
    value: 3,
  },
  {
    label: DANISH,
    value: 4,
  },
  {
    label: GERMAN,
    value: 5,
  },
  {
    label: BASQUE,
    value: 59,
  },
  {
    label: SPANISH_SPAIN,
    value: 7,
  },
  {
    label: GUARANI,
    value: 66,
  },
  {
    label: FINNISH,
    value: 8,
  },
  {
    label: FRENCH_FRANCE,
    value: 9,
  },
  {
    label: GALICIAN,
    value: 65,
  },
  {
    label: HUNGARIAN,
    value: 30,
  },
  {
    label: ITALIAN,
    value: 10,
  },
  {
    label: JAPANESE,
    value: 11,
  },
  {
    label: KOREAN,
    value: 12,
  },
  {
    label: NORWEGIAN_BOKMAL,
    value: 13,
  },
  {
    label: NORWEGIAN_NYNORSK,
    value: 84,
  },
  {
    label: DUTCH,
    value: 14,
  },
  {
    label: FRISIAN,
    value: 63,
  },
  {
    label: POLISH,
    value: 15,
  },
  {
    label: PORTUGUESE_BRAZIL,
    value: 16,
  },
  {
    label: PORTUGUESE_PORTUGAL,
    value: 31,
  },
  {
    label: ROMANIAN,
    value: 32,
  },
  {
    label: RUSSIAN,
    value: 17,
  },
  {
    label: SLOVAK,
    value: 33,
  },
  {
    label: SLOVENIAN,
    value: 34,
  },
  {
    label: SWEDISH,
    value: 18,
  },
  {
    label: THAI,
    value: 35,
  },
  {
    label: TURKISH,
    value: 19,
  },
  {
    label: NORTHERN_KURDISH_KURMANJI,
    value: 76,
  },
  {
    label: MANDARIN,
    value: 20,
  },
  {
    label: TRADITIONAL_CHINESE_HONG_KONG,
    value: 21,
  },
  {
    label: TRADITIONAL_CHINESE_TAIWAN,
    value: 22,
  },
  {
    label: AFRIKAANS,
    value: 36,
  },
  {
    label: ALBANIAN,
    value: 87,
  },
  {
    label: ARMENIAN,
    value: 68,
  },
  {
    label: AZERBAIJANI,
    value: 53,
  },
  {
    label: BELARUSIAN,
    value: 54,
  },
  {
    label: BENGALI,
    value: 45,
  },
  {
    label: BOSNIAN,
    value: 55,
  },
  {
    label: BULGARIAN,
    value: 37,
  },
  {
    label: CROATIAN,
    value: 38,
  },
  {
    label: FLEMISH,
    value: 83,
  },
  {
    label: ENGLISH_UK,
    value: 24,
  },
  {
    label: ESPERANTO,
    value: 57,
  },
  {
    label: ESTONIAN,
    value: 58,
  },
  {
    label: FAROESE,
    value: 62,
  },
  {
    label: FRENCH_CANADA,
    value: 44,
  },
  {
    label: GEORGIAN,
    value: 72,
  },
  {
    label: GREEK,
    value: 39,
  },
  {
    label: GUJARATI,
    value: 67,
  },
  {
    label: HINDI,
    value: 46,
  },
  {
    label: ICELANDIC,
    value: 69,
  },
  {
    label: INDONESIAN,
    value: 25,
  },
  {
    label: IRISH,
    value: 64,
  },
  {
    label: JAVANESE,
    value: 71,
  },
  {
    label: KANNADA,
    value: 75,
  },
  {
    label: KAZAKH,
    value: 73,
  },
  {
    label: LATVIAN,
    value: 78,
  },
  {
    label: LITHUANIAN,
    value: 40,
  },
  {
    label: MACEDONIAN,
    value: 79,
  },
  {
    label: MALAY,
    value: 41,
  },
  {
    label: MARATHI,
    value: 81,
  },
  {
    label: MONGOLIAN,
    value: 80,
  },
  {
    label: NEPALI,
    value: 82,
  },
  {
    label: PUNJABI,
    value: 47,
  },
  {
    label: SERBIAN,
    value: 42,
  },
  {
    label: SWAHILI,
    value: 88,
  },
  {
    label: FILIPINO,
    value: 26,
  },
  {
    label: TAMIL,
    value: 48,
  },
  {
    label: TELUGU,
    value: 49,
  },
  {
    label: MALAYALAM,
    value: 50,
  },
  {
    label: UKRAINIAN,
    value: 52,
  },
  {
    label: UZBEK,
    value: 91,
  },
  {
    label: VIETNAMESE,
    value: 27,
  },
  {
    label: KHMER,
    value: 74,
  },
  {
    label: TAJIK,
    value: 89,
  },
  {
    label: ARABIC,
    value: 28,
  },
  {
    label: HEBREW,
    value: 29,
  },
  {
    label: URDU,
    value: 90,
  },
  {
    label: PERSIAN,
    value: 60,
  },
  {
    label: PASHTO,
    value: 85,
  },
  {
    label: SINHALA,
    value: 86,
  },
  {
    label: JAPANESE_KANSAI,
    value: 70,
  },
  {
    label: ENGLISH,
    value: 1001,
  },
  {
    label: SPANISH,
    value: 1002,
  },
  {
    label: FRENCH,
    value: 1003,
  },
  {
    label: CHINESE,
    value: 1004,
  },
  {
    label: PORTUGUESE,
    value: 1005,
  },
];

export const LANGUAGES_TIKTOK_OPTIONS = [
  {
    label: ARABIC,
    value: "ar",
  },
  {
    label: ASSAMESE,
    value: "as",
  },
  {
    label: HARYANAVI,
    value: "bgc",
  },
  {
    label: BIHARI,
    value: "bh",
  },
  {
    label: BENGALI,
    value: "bn",
  },
  {
    label: CZECH,
    value: "cs",
  },
  {
    label: GERMAN,
    value: "de",
  },
  {
    label: GREEK,
    value: "el",
  },
  {
    label: ENGLISH,
    value: "en",
  },
  {
    label: SPANISH,
    value: "es",
  },
  {
    label: FINNISH,
    value: "fi",
  },
  {
    label: FRENCH,
    value: "fr",
  },
  {
    label: GUJARATI,
    value: "gu",
  },
  {
    label: HEBREW,
    value: "he",
  },
  {
    label: HINDI,
    value: "hi",
  },
  {
    label: HUNGARIAN,
    value: "hu",
  },
  {
    label: INDONESIAN,
    value: "id",
  },
  {
    label: ITALIAN,
    value: "it",
  },
  {
    label: JAPANESE,
    value: "ja",
  },
  {
    label: KANNADA,
    value: "kn",
  },
  {
    label: KOREAN,
    value: "ko",
  },
  {
    label: MALAYALAM,
    value: "ml",
  },
  {
    label: MARATHI,
    value: "mr",
  },
  {
    label: MALAY,
    value: "ms",
  },
  {
    label: DUTCH,
    value: "nl",
  },
  {
    label: ORIYA,
    value: "or",
  },
  {
    label: PUNJABI,
    value: "pa",
  },
  {
    label: POLISH,
    value: "pl",
  },
  {
    label: PORTUGUESE,
    value: "pt",
  },
  {
    label: RAJASTHANI,
    value: "raj",
  },
  {
    label: ROMANIAN,
    value: "ro",
  },
  {
    label: RUSSIAN,
    value: "ru",
  },
  {
    label: SWEDISH,
    value: "sv",
  },
  {
    label: TAMIL,
    value: "ta",
  },
  {
    label: TELUGU,
    value: "te",
  },
  {
    label: THAI,
    value: "th",
  },
  {
    label: TURKISH,
    value: "tr",
  },
  {
    label: UKRAINIAN,
    value: "uk",
  },
  {
    label: VIETNAMESE,
    value: "vi",
  },
  {
    label: MANDARIN,
    value: "zh",
  },
  {
    label: TRADITIONAL_CHINESE_HONG_KONG,
    value: "zh-Hant",
  },
];

export const LANGUAGES_GOOGLE_OPTIONS = [
  {
    label: ENGLISH,
    value: "languageConstants/1000",
  },
  {
    label: GERMAN,
    value: "languageConstants/1001",
  },
  {
    label: FRENCH,
    value: "languageConstants/1002",
  },
  {
    label: SPANISH,
    value: "languageConstants/1003",
  },
  {
    label: ITALIAN,
    value: "languageConstants/1004",
  },
  {
    label: JAPANESE,
    value: "languageConstants/1005",
  },
  {
    label: DANISH,
    value: "languageConstants/1009",
  },
  {
    label: DUTCH,
    value: "languageConstants/1010",
  },
  {
    label: FINNISH,
    value: "languageConstants/1011",
  },
  {
    label: KOREAN,
    value: "languageConstants/1012",
  },
  {
    label: NORWEGIAN,
    value: "languageConstants/1013",
  },
  {
    label: PORTUGUESE,
    value: "languageConstants/1014",
  },
  {
    label: SWEDISH,
    value: "languageConstants/1015",
  },
  {
    label: MANDARIN,
    value: "languageConstants/1017",
  },
  {
    label: TRADITIONAL_CHINESE_HONG_KONG,
    value: "languageConstants/1018",
  },
  {
    label: ARABIC,
    value: "languageConstants/1019",
  },
  {
    label: BULGARIAN,
    value: "languageConstants/1020",
  },
  {
    label: CZECH,
    value: "languageConstants/1021",
  },
  {
    label: GREEK,
    value: "languageConstants/1022",
  },
  {
    label: HINDI,
    value: "languageConstants/1023",
  },
  {
    label: HUNGARIAN,
    value: "languageConstants/1024",
  },
  {
    label: INDONESIAN,
    value: "languageConstants/1025",
  },
  {
    label: ICELANDIC,
    value: "languageConstants/1026",
  },
  {
    label: HEBREW,
    value: "languageConstants/1027",
  },
  {
    label: LATVIAN,
    value: "languageConstants/1028",
  },
  {
    label: LITHUANIAN,
    value: "languageConstants/1029",
  },
  {
    label: POLISH,
    value: "languageConstants/1030",
  },
  {
    label: RUSSIAN,
    value: "languageConstants/1031",
  },
  {
    label: ROMANIAN,
    value: "languageConstants/1032",
  },
  {
    label: SLOVAK,
    value: "languageConstants/1033",
  },
  {
    label: SLOVENIAN,
    value: "languageConstants/1034",
  },
  {
    label: SERBIAN,
    value: "languageConstants/1035",
  },
  {
    label: UKRAINIAN,
    value: "languageConstants/1036",
  },
  {
    label: TURKISH,
    value: "languageConstants/1037",
  },
  {
    label: CATALAN,
    value: "languageConstants/1038",
  },
  {
    label: CROATIAN,
    value: "languageConstants/1039",
  },
  {
    label: VIETNAMESE,
    value: "languageConstants/1040",
  },
  {
    label: URDU,
    value: "languageConstants/1041",
  },
  {
    label: FILIPINO,
    value: "languageConstants/1042",
  },
  {
    label: ESTONIAN,
    value: "languageConstants/1043",
  },
  {
    label: THAI,
    value: "languageConstants/1044",
  },
  {
    label: BENGALI,
    value: "languageConstants/1056",
  },
  {
    label: PERSIAN,
    value: "languageConstants/1064",
  },
  {
    label: GUJARATI,
    value: "languageConstants/1072",
  },
  {
    label: KANNADA,
    value: "languageConstants/1086",
  },
  {
    label: MALAYALAM,
    value: "languageConstants/1098",
  },
  {
    label: MARATHI,
    value: "languageConstants/1101",
  },
  {
    label: MALAY,
    value: "languageConstants/1102",
  },
  {
    label: PUNJABI,
    value: "languageConstants/1110",
  },
  {
    label: TAMIL,
    value: "languageConstants/1130",
  },
  {
    label: TELUGU,
    value: "languageConstants/1131",
  },
];

/**
 * ISO 639-1 language codes for Google Dynamic Search Ads campaign language
 * (dynamicSearchAdsSetting.language). Not the same resource names as
 * LANGUAGES_GOOGLE_OPTIONS (language targeting).
 */
export const LANGUAGES_GOOGLE_DSA_OPTIONS = [
  { label: SPANISH, value: "es" },
  { label: ENGLISH, value: "en" },
  { label: PORTUGUESE, value: "pt" },
  { label: FRENCH, value: "fr" },
  { label: RUSSIAN, value: "ru" },
  { label: JAPANESE, value: "ja" },
  { label: MANDARIN, value: "zh" },
  { label: HINDI, value: "hi" },
  { label: ARABIC, value: "ar" },
  { label: GERMAN, value: "de" },
  { label: KOREAN, value: "ko" },
  { label: DANISH, value: "da" },
  { label: BULGARIAN, value: "bg" },
  { label: SLOVAK, value: "sk" },
  { label: CROATIAN, value: "hr" },
  { label: INDONESIAN, value: "id" },
  { label: TURKISH, value: "tr" },
  { label: UKRAINIAN, value: "uk" },
];

export const LANGUAGES_LINKEDIN_OPTIONS = [
  {
    label: ARABIC,
    value: "urn:li:locale:ar_AE",
  },
  {
    label: CZECH,
    value: "urn:li:locale:cs_CZ",
  },
  {
    label: DANISH,
    value: "urn:li:locale:da_DK",
  },
  {
    label: DUTCH,
    value: "urn:li:locale:nl_NL",
  },
  {
    label: ENGLISH,
    value: "urn:li:locale:en_US",
  },
  {
    label: FRENCH,
    value: "urn:li:locale:fr_FR",
  },
  {
    label: GERMAN,
    value: "urn:li:locale:de_DE",
  },
  {
    label: HINDI,
    value: "urn:li:locale:hi_IN",
  },
  {
    label: INDONESIAN,
    value: "urn:li:locale:in_ID",
  },
  {
    label: ITALIAN,
    value: "urn:li:locale:it_IT",
  },
  {
    label: JAPANESE,
    value: "urn:li:locale:ja_JP",
  },
  {
    label: KOREAN,
    value: "urn:li:locale:ko_KR",
  },
  {
    label: MALAY,
    value: "urn:li:locale:ms_MY",
  },
  {
    label: NORWEGIAN,
    value: "urn:li:locale:no_NO",
  },
  {
    label: POLISH,
    value: "urn:li:locale:pl_PL",
  },
  {
    label: PORTUGUESE,
    value: "urn:li:locale:pt_BR",
  },
  {
    label: ROMANIAN,
    value: "urn:li:locale:ro_RO",
  },
  {
    label: RUSSIAN,
    value: "urn:li:locale:ru_RU",
  },
  {
    label: SPANISH,
    value: "urn:li:locale:es_ES",
  },
  {
    label: SWEDISH,
    value: "urn:li:locale:sv_SE",
  },
  {
    label: TURKISH,
    value: "urn:li:locale:tr_TR",
  },
  {
    label: GREEK,
    value: "urn:li:locale:el_GR",
  },
];

const CATALOG_BY_PLATFORM = {
  meta: LANGUAGE_OPTIONS_META,
  google: LANGUAGES_GOOGLE_OPTIONS,
  tiktok: LANGUAGES_TIKTOK_OPTIONS,
  linkedin: LANGUAGES_LINKEDIN_OPTIONS,
};

/**
 * Resolve raw language value (id, code, URN) to human label.
 * @param {string} platform - Platform key (meta, google, tiktok, linkedIn)
 * @param {string|number} value - Raw value from form/log
 * @param {(key: string) => string} t - i18n function
 * @returns {string}
 */
export const getLanguageLabel = (platform, value, t) => {
  const platformKey = String(platform || "").toLowerCase();
  const catalog = CATALOG_BY_PLATFORM[platformKey];
  if (!catalog) return String(value ?? "");
  const opt = catalog.find(
    (o) =>
      String(o.value) === String(value) || Number(o.value) === Number(value)
  );
  return opt ? t(opt.label) : String(value ?? "");
};
